import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ProjectPDFLink,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateSixPDFSectionWithSubsections as TemplateSixPDFSection } from "./common";
import { ResumePDFIcon } from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeCertificate } from "lib/redux/types";

export const Certificate = ({
  heading,
  certifications,
  themeColor,
  isPDF,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  certifications: ResumeCertificate[];
  themeColor: string;
  isPDF: boolean;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateSixPDFSection themeColor={themeColor} heading={heading}>
      {certifications.map(
        ({ certificate, certificateLink, descriptions }, idx) => (
          <View key={idx} wrap={false}>
            <View style={{ marginTop: spacing["0.5"] }}>
              <View
                style={{
                  marginTop: spacing["0.5"],
                }}
              >
                <View
                  style={{
                    ...styles.flexRow,
                    gap: spacing["2"],
                  }}
                >
                  <ResumePDFText bold={true}>{certificate}</ResumePDFText>
                  {certificateLink && (
                    <ProjectPDFLink src={certificateLink}>
                      <ResumePDFIcon
                        type="url"
                        isPDF={isPDF}
                        themeColor={themeColor}
                      />
                    </ProjectPDFLink>
                  )}
                </View>
              </View>
              <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
                <ResumePDFDescription 
                  items={descriptions} 
                  enableHighlight={enableHighlight}
                  enableMistakeHighlight={enableMistakeHighlight}
                  section="certificates"
                  itemIndex={idx}
                />
              </View>
            </View>
          </View>
        )
      )}
    </TemplateSixPDFSection>
  );
};
